module.exports = __webpack_public_path__ + "img/Mail.a2629ab3.svg";